module.exports = __webpack_public_path__ + "img/bayMtn4.e1061a6f.png";